import React from 'react';
import { CrowBeeldkwaliteitScore } from '../../../../common/src/domain/customInspectionTypes/crowBeeldkwaliteit/crowBeeldkwaliteitScore';
import { crowBeeldkwaliteitScoreToColorCode } from '../../../../common/src/domain/customInspectionTypes/crowBeeldkwaliteit/crowBeeldkwaliteitScoreToColorCode';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CrowBeeldkwaliteitScoreLabel = React.memo(function CrowBeeldkwaliteitScoreLabel(props: {
    crowScore?: CrowBeeldkwaliteitScore | undefined | null;
}) {
    if (props.crowScore === null || props.crowScore === undefined) {
        return null;
    }
    const colorCode = crowBeeldkwaliteitScoreToColorCode(props.crowScore);

    return (
        <span className="label p5 fs11" style={{ backgroundColor: colorCode }}>
            {props.crowScore}
        </span>
    );
});
